// ============================================================
// HEADER COMPONENT
// ============================================================

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Search, Bell, Sun, Moon, Menu, LogOut } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { NAV_ITEMS } from '../../utils/constants';

const Header = ({ collapsed, onMenuToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { darkMode, toggleTheme } = useTheme();
  const { user, logout } = useAuth();

  const currentPage = NAV_ITEMS.find(n => n.path === location.pathname);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <header className={`admin-header ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="admin-header-left">
        <button
          className="admin-header-btn"
          onClick={onMenuToggle}
          style={{ display: 'none' }}
          id="mobile-menu-btn"
        >
          <Menu size={18} />
        </button>
        <div className="admin-breadcrumb">
          <span>Admin</span>
          <span>/</span>
          <span>{currentPage?.label || 'Dashboard'}</span>
        </div>
      </div>

      <div className="admin-header-search">
        <Search size={14} className="admin-header-search-icon" />
        <input type="text" placeholder="Search anything..." />
      </div>

      <div className="admin-header-right">
        <button className="admin-header-btn" onClick={toggleTheme} title="Toggle theme">
          {darkMode ? <Sun size={16} /> : <Moon size={16} />}
        </button>

        <button className="admin-header-btn" title="Notifications">
          <Bell size={16} />
          <span className="admin-header-notif-badge">5</span>
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div className="admin-header-avatar" onClick={() => navigate('/admin/profile')}>
            {user?.name?.charAt(0) || 'A'}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--admin-text)', cursor: 'pointer' }}
              onClick={() => navigate('/admin/profile')}>
              {user?.name || 'Admin'}
            </span>
            <span style={{ fontSize: 11, color: 'var(--admin-text-muted)' }}>{user?.role}</span>
          </div>
        </div>

        <button className="admin-header-btn" onClick={handleLogout} title="Logout">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
};

export default Header;
